import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Typography } from '@mui/material';

export default function TelemetryTableValidator({
  telemetrymetadata,
  liftTelemetryFileMetaData,
  selectedRunDetails,
}) {
  const [selectedRow, setSelectedRow] = React.useState();

  function handleClick(event, rownum) {
    console.log(rownum);
    setSelectedRow(rownum);
  }

  function filterRunDetails(data) {
    let racerLaps = [];
    if (data.runJson && data.racerId) {
      racerLaps = data?.runJson?.results?.filter(
        (res) => res.racer_number === data?.racerId
      )[0].laps;
      return racerLaps;
    } else {
      return null;
    }
  }
  // this will evolve, but for now we assume that RaceHero laps are always correct
  // and we always have at least as many telemetry laps as racehero laps
  React.useEffect(() => {
    const rhlaps = filterRunDetails(selectedRunDetails);
    if (rhlaps) {
      liftTelemetryFileMetaData((t, i) => {
        return {
          ...t,
          RunLapMapping: t.BeaconMarkers.map((m, i) => ({
            TelemetryLapIndex: i,
            TelemetryLapNumber: i + 1,
            RunLapNumber: selectedRow <= i ? i + 1 - selectedRow : null,
            RunLapTime: selectedRow <= i ? rhlaps[i - selectedRow]?.time : null,
          })),
        };
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRow, selectedRunDetails]);

  if (
    !telemetrymetadata ||
    !telemetrymetadata.BeaconMarkers ||
    !telemetrymetadata.SegmentTimes ||
    !telemetrymetadata.LapArrayIndexes ||
    !telemetrymetadata.LapTimeData
  ) {
    console.log(telemetrymetadata);
    return <div>No data available</div>;
  }
  const { BeaconMarkers, SegmentTimes, LapArrayIndexes, LapTimeData } =
    telemetrymetadata;
  return (
    <React.Fragment>
      {/* {mergedRows && <pre>boop{JSON.stringify(mergedRows, null, 2)}</pre>} */}
      <Typography variant="h6" gutterBottom>
        Telemetry Data Summary
      </Typography>
      <Typography variant="body1" gutterBottom>
        Total Laps: {LapArrayIndexes.length}
      </Typography>
      <Typography variant="body1" gutterBottom>
        Select the lap below that corresponds to RaceHero lap 1 of{' '}
        {filterRunDetails(selectedRunDetails)[0].time &&
          filterRunDetails(selectedRunDetails)[0].time}
      </Typography>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 250 }} size="small" aria-label="telemetry table">
          <TableHead>
            <TableRow>
              <TableCell>Lap Number</TableCell>
              <TableCell align="right">Beacon Marker</TableCell>
              <TableCell align="right">SegmentTimes</TableCell>
              <TableCell align="right">LapArrayIndexes</TableCell>
              <TableCell align="right">LapTimeData</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {BeaconMarkers.map((marker, index) => (
              <TableRow
                hover
                key={index}
                selected={selectedRow === index}
                sx={{
                  '&:last-child td, &:last-child th': { border: 0 },
                }}
                onClick={(event) => handleClick(event, index)}
              >
                <TableCell component="th" scope="row">
                  {index + 1}
                </TableCell>
                <TableCell align="right">{marker}</TableCell>
                <TableCell align="right">{SegmentTimes[index]}</TableCell>
                <TableCell align="right">{LapArrayIndexes[index]}</TableCell>
                <TableCell align="right">{LapTimeData[index]}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </React.Fragment>
  );
}
